import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { useState } from "react";
import { boatsFetch } from "../../../../lib/boatsFetch";
import { YachtsFiltersFormT } from "./yachts-filters.schema";
import { ComboboxMulti } from "../../../../components/ui/combobox-multi";

type YachtName = {
  name: string;
  entityType: "yacht";
};

export const YachtName = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Yacht name</h3>
      <FormField<YachtsFiltersFormT, "yachtName">
        name="yachtName"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <ComboboxMulti<YachtName>
                className="flex w-96"
                loadOptions={(query) => {
                  const data = boatsFetch<{ data: any[]; success: boolean }>(
                    `/search/yacht-names${query ? `?query=${query}` : ""}`,
                  ).then((r) =>
                    r.data?.map((y) => {
                      return {
                        value: y.name?.[0],
                        label: y.name?.[0],
                      };
                    }),
                  );
                  return data;
                }}
                placeholder="Search for yacht..."
                value={field.value ?? []}
                onChange={(v) => {
                  field.onChange(v);
                }}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
};
